import React, { useState, useEffect, JSX } from 'react'
import ClipLoader from "react-spinners/ClipLoader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { Select, Button, Menu, MenuItem } from '@mui/material';
import ApiFailed from '../../Utils/ApiFailed';
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, DataGridTypes } from 'devextreme-react/data-grid';
import Modal from 'react-bootstrap/Modal'
import { CreateUrl, CallGetAPI, CallPutAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import {useMobileLandscape } from '../../Context/ContextProvider'

interface User {
    id: number;
    userId: string;
    userName: string;
    level: string;
    companyGuid: string;
    companyName: string;
    servers: Array<string>;
    lockedOut: boolean;
    lastLogin: Date | null;
    config: boolean;
    language: string
    graphTotaliser: boolean
}


const AdminUsersMobile: React.FC = () => {
    const isLandscape = useMobileLandscape()
    const [loading, setLoading] = useState<boolean>(false)
    const [tableHidden, setTableHidden] = useState<boolean>(false)
    const [userData, setUserData] = useState<Array<User>>([])
    const [anchorEl, setAnchorEl] = useState<EventTarget & HTMLElement | null>(null)
    const [tempUser, setTempUser] = useState<User | null | undefined>(null)
    const [passwordModal, setPasswordModal] = useState<boolean>(false)
    useEffect(() => {
        reloadData(null)
    }, [])




    const reloadData = (editId: number | null): void => {
        setLoading(true)
        CallGetAPI(CreateUrl('/api/aquaguard/AdminUsers'), {})
            .then((data: User[]) => {
                if (data.length > 0) {
                    setUserData(data)
                    setLoading(false)

                } else {
                    setUserData([])
                    setLoading(false)
                }

              
            })
            .catch((err) => {
                console.error(err)
                setTableHidden(true)
                setLoading(false)
            });
    }

    const impersonateUser = (): void => {
        console.log(tempUser)
        if (tempUser) {
            window.sessionStorage.setItem('impersonateCompany', tempUser.companyGuid);
            window.sessionStorage.setItem('impersonateUser', tempUser.userId);
        }
        // Force refresh to update NavBar
        window.location.reload();
        setAnchorEl(null)
    }

   
    const moreRender = (data: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        return (
            <IconButton size="small" onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => { handleClick(e, data.data.id); }}><MoreHorizIcon /></IconButton>
        );
    }

    const handleClick = (e: React.MouseEvent<HTMLElement>, id: number): void => {
        const user: User | null | undefined = userData.find(u => u.id === id)
        setAnchorEl(e.currentTarget)
        setTempUser(user)
        console.log(id)

    }

    const togglePasswordModal = ():void => {
        setPasswordModal(!passwordModal)
        setAnchorEl(null)
    }


    const resetPassword = (): void => {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                UserId: tempUser?.id,
                UserName: tempUser?.userName,
                newPassword: "Passw0rd!",
                oldPassword: "",
                userGuid: tempUser?.userId,
            })
        };

        CallGetAPI(CreateUrl('/api/aquaguard/UserPassword'), requestOptions)
            .then(() => {
                createSuccessNotification();
                setPasswordModal(!passwordModal)
            },
                // Reject
                () => {
                    createErrorNotification();
                    setPasswordModal(!passwordModal)
                })
            .catch(function (error) {
                createErrorNotification();
                console.log(error);
                setPasswordModal(!passwordModal)
            });
    }

    const createSuccessNotification = (): void => {
        NotificationManager.success('Saved Changes', 'Success')

    };

    const createErrorNotification = (): void => {
        NotificationManager.error('Error Saving Changes', 'Click me!', 5000, () => {
            alert('callback');
        });
    };

    return (
        <div>
            {loading && <div style={{
                position: 'absolute', left: '50%', top: '50%',
                transform: 'translate(-50%, -50%)'
            }}>
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={loading}
                />
            </div>}
            {!loading && <div>
                {tableHidden && <ApiFailed />}
                {!tableHidden &&
                    
                    <div style={{ width: isLandscape? '100%' : "118%", transform: isLandscape? 'translateX(0)' : "translateX(-8%)" }}>
                        <Modal
                            show={passwordModal}
                            onHide={(): void => togglePasswordModal()}
                            dialogClassName="modal-90w"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                            scrolling={{
                                mode: 'standard',
                                useNative: false
                            }}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                        >

                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    Reset Password
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="show-grid">
                                User {tempUser?.userName} will have password reset to <b>Passw0rd!</b> and be required to reset a secure password when they next login.<br />
                                Do you want to continue?
                            </Modal.Body>
                            <Modal.Footer>
                                <div style={{marginBottom: "10px", width: "100%"} }>
                                    <FullWidthMobileButton disabled={false} onClick={(): void => resetPassword()} color='primary' text="Continue" />
                                </div>
                                <FullWidthMobileButton disabled={false} onClick={(): void => togglePasswordModal()} color='error' text="Cancel" />
                            </Modal.Footer>
                        </Modal>
                        <Card>
                            <CardHeader color="primary" className="view view-cascade  d-flex justify-content-between align-items-center py-2 mx-4 mb-3">
                                <h4 style={{ textAlign: "center", marginLeft: "10px" }}>Manage Users</h4>
                            </CardHeader>
                            <CardBody>
                                {console.log(userData) }
                                <DataGrid
                                    dataSource={userData}>
                                    <StateStoring enabled={true} type="localStorage" storageKey="UserListGrid" />
                                    <FilterRow visible={true} />
                                    <GroupPanel visible={true} />
                                    <Grouping autoExpandAll={true} />
                                    <HeaderFilter visible={true} />
                                    <Column dataField="userName" dataType="string" />
                                    <Column dataField="level" dataType="string" width={80 } />
                                    <Column fixed={true} fixedPosition='right' type="buttons" cellRender={(e): React.ReactNode => moreRender(e)} width={50} />
                                </DataGrid>
                            </CardBody>
                        </Card>

                    </div>
                }
                <Menu
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                >
                    <MenuItem onClick={(): void => impersonateUser()}>Impersonate User</MenuItem>
                    <MenuItem onClick={():void => togglePasswordModal()}>Force Password Reset</MenuItem>
                </Menu>
            </div>

            }
        </div>
    )
}
export default AdminUsersMobile